module.exports = __webpack_public_path__ + "img/Herd1.c258af28.png";